/* Этот маппинг имеет смысл ради получения единого кода клавиш вне зависимости от раскладки */
export enum KEY_CODE {
    ESCAPE = "Escape",
    ESCAPE_IE_11 = "Esc",
    ENTER = "Enter",
    SPACE = " ",
    ARROW_LEFT = "ArrowLeft",
    ARROW_LEFT_IE11 = "Left", // ie 11 key
    ARROW_UP = "ArrowUp",
    ARROW_RIGHT = "ArrowRight",
    ARROW_RIGHT_IE11 = "Right", // ie 11 key
    ARROW_DOWN = "ArrowDown",
    M = "M",
    SHIFT = "Shift",
    TAB = "Tab",
}
